/**
 * useOrderSound — plays alert tones using Web Audio API.
 * Handles browser autoplay policy by unlocking audio on first user interaction.
 */

let audioCtx = null;
let unlocked = false;

function getContext() {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  return audioCtx;
}

// Call this on any user click anywhere in the app to unlock audio
export function unlockAudio() {
  if (unlocked) return;
  try {
    const ctx = getContext();
    // Play a silent buffer to unlock
    const buf = ctx.createBuffer(1, 1, 22050);
    const src = ctx.createBufferSource();
    src.buffer = buf;
    src.connect(ctx.destination);
    src.start(0);
    if (ctx.state === 'suspended') {
      ctx.resume();
    }
    unlocked = true;
  } catch (e) {
    console.warn('Audio unlock failed:', e);
  }
}

function playTone(frequency, duration, type = 'sine', volume = 0.4) {
  try {
    const ctx = getContext();
    if (ctx.state === 'suspended') ctx.resume();

    const oscillator = ctx.createOscillator();
    const gainNode   = ctx.createGain();
    oscillator.connect(gainNode);
    gainNode.connect(ctx.destination);
    oscillator.type = type;
    oscillator.frequency.setValueAtTime(frequency, ctx.currentTime);
    gainNode.gain.setValueAtTime(volume, ctx.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);
    oscillator.start(ctx.currentTime);
    oscillator.stop(ctx.currentTime + duration);
  } catch (e) {
    console.warn('Audio playback failed:', e);
  }
}

// Kitchen alert — urgent triple beep when a new order comes in
export function playKitchenAlert() {
  playTone(440, 0.15, 'square', 0.35);
  setTimeout(() => playTone(440, 0.15, 'square', 0.35), 220);
  setTimeout(() => playTone(440, 0.15, 'square', 0.35), 440);
}

// Waiter alert — ding-dong when order is ready
export function playReadyAlert() {
  playTone(880, 0.25, 'sine', 0.45);
  setTimeout(() => playTone(660, 0.35, 'sine', 0.45), 300);
  setTimeout(() => playTone(780, 0.4,  'sine', 0.35), 650);
}